import React from 'react';
import { validateExternalUrl } from './externalUrl';

export const openLinkInNewTabViaJs = (
  e: React.MouseEvent<HTMLElement> | undefined,
  href: string | undefined,
  target: string = '_blank'
) => {
  if (!href) {
    return;
  }

  e && e.preventDefault();
  window.open(validateExternalUrl(href), target);
};
